import * as React from 'react';
import { useContext } from 'react';

import type { ApolloError } from '@apollo/client';

import type { ConsumerPageHeader_MyPageHeaderFragment as MyPageHeader } from 'bundles/composable-page-header-consumer/queries/__generated__/ConsumerMyPageHeaderQuery';

type ConsumerMyPageHeaderContextType = {
  myPageHeader?: MyPageHeader;
  hasEnrolledPrograms?: boolean;
  // To be used to indicate to page header renderers that we may want to render a fallback header as the call to get the header data failed if this is defined.
  error?: ApolloError;
};

const ConsumerMyPageHeaderContext = React.createContext<ConsumerMyPageHeaderContextType | undefined>(undefined);

export const useConsumerMyPageHeader = () => {
  const context = useContext(ConsumerMyPageHeaderContext);
  const enrolledDegreePrograms = context?.myPageHeader?.enrolledDegreePrograms;
  const enrolledEnterprisePrograms = context?.myPageHeader?.enrolledEnterprisePrograms;
  const hasEnrolledPrograms =
    (enrolledDegreePrograms && enrolledDegreePrograms.length > 0) ||
    (enrolledEnterprisePrograms && enrolledEnterprisePrograms.length > 0);

  return {
    enrolledDegreePrograms,
    enrolledEnterprisePrograms,
    chosenEnterpriseProgram: context?.myPageHeader?.chosenEnterpriseProgram,
    chosenDegree: context?.myPageHeader?.chosenDegree,
    hasCheatingIncidents: context?.myPageHeader?.hasCheatingIncidents,
    canViewEducatorAdminLink: context?.myPageHeader?.canViewEducatorAdminLink,
    isCourseraPlusLearner: context?.myPageHeader?.isCourseraPlusLearner,
    naptimeManagedThirdPartyOrganizations: context?.myPageHeader?.naptimeManagedThirdPartyOrganizations,
    hasEnrolledPrograms,
  };
};

export const useConsumerMyPageHeaderError = () => {
  const context = useContext(ConsumerMyPageHeaderContext);

  return context?.error;
};

export default ConsumerMyPageHeaderContext;
